<template>
  <div id="app">
    <Headers></Headers>
    <div class="center">
      <div class="h1">
        <div class="w">
          <div class="l">
            <div class="animate__animated animate__fadeInUpBig text text1">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;天相股多多
            </div>
            <div class="animate__animated animate__fadeInUpBig text text2">
              专注智能擒龙研发
            </div>
          </div>
          <img
            class="r animate__animated animate__fadeInUpBig"
            src="../assets/img/product/computer.png"
            alt=""
          />
        </div>
      </div>
      <div class="h2">
        <div class="w">
          <div class="l animate__animated animate__fadeInUpBig">
            <h3>天相股多多</h3>
            <div class="text">
              适合激进型投资者：龙头股的发展有四个阶段，分别为启动、加速、主升、回调，不同阶段，匹配
              不同的数据分析，监控与研究每个涨停板背后的特征与本质，提前挖掘出有溢价空间的龙头股，专为短线投资者打造。
            </div>
          </div>
          <div class="r animate__animated animate__fadeInUpBig">
            <img src="../assets/img/product/5.png" alt="" />
          </div>
        </div>
      </div>
      <div class="h3">
        <div class="w">
          <div class="l">
            <div class="text1">龙头雷达</div>
            <div class="text2">
              多屏合一，从板块到个股,全方位监控,不错过任何异动,锁定每日强势龙头股。
            </div>
          </div>
          <div class="r">
            <img src="../assets/img/product/龙头雷达.png" alt="" />
          </div>
        </div>
      </div>
      <div class="h4">
        <div class="w">
          <div class="l">
            <img src="../assets/img/product/龙头启动.png" alt="" />
          </div>
          <div class="r">
            <div class="text1">龙头启动</div>
            <div class="text2">
              涨停板是龙头股启动的核心标志，然而首板个股鱼龙混杂，投资者很难辨别哪只才是未来的真潜龙。透过龙头启动功能，助力投资者层层提炼精选，捕捉首板潜力龙头股。
            </div>
          </div>
        </div>
      </div>
      <div class="h3">
        <div class="w">
          <div class="l">
            <div class="text1">龙头二波</div>
            <div class="text2">
              在股市中，龙头股向来是短线热钱博弈较为激烈的地方，龙头行业和公司具有天然的竞争优势。但龙头股涨势凶猛，一味追高风险会比较大。龙头二波功能，在龙头股连续回调到位后再次启动的时机介入，是基于龙头股再次上涨惯性的操作模式。
            </div>
          </div>
          <div class="r">
            <img src="../assets/img/product/龙头二波.png" alt="" />
          </div>
        </div>
      </div>
      <div class="h4">
        <div class="w">
          <div class="l">
            <img src="../assets/img/product/龙头主升.png" alt="" />
          </div>
          <div class="r">
            <div class="text1">龙头主升</div>
            <div class="text2">
              二板定龙头股，对于市场游资，往往在第二个涨停板进场，对于强势股来说，以连续的涨停板从市场中脱颖而出的。透过龙头主升功能，助力投资者跟上龙头股主升波段。
            </div>
          </div>
        </div>
      </div>
      <div class="h10">
        <div class="w">
          <div class="lis1">经营证券期货业务许可证公示</div>
          <div class="lis2">
            <div class="l">
              <img src="../assets/img/userService/csrc.png" alt="" />
              <div class="right">
                <!-- 91110102MA001GJE1N -->
                <div class="p1">
                  经营证券期货业务许可证 统一社会信用代码：91110102MA001GJE1N
                </div>
                <div class="p1">
                  从事证劵投资或期货交易，请通过合法证券期货经营机构进行，合法机构名单可到中国证监会
                  网站（www.csrc.gov.cn）查询。 投资有风险，入市需谨慎！
                </div>
              </div>
            </div>
            <div class="r">
              <div class="p1" style="margin-bottom: 10px">
                咨询电话：010-66045051
              </div>
              <div class="p2">申诉电话：400-101-8662</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>
<script>
import Headers from "../components/headers";
import Bottom from "../components/bottom";
export default {
  name: "product",
  components: {
    Headers,
    Bottom,
  },
};
</script>

<style lang="less" scoped>
.h1 {
  width: 100%;
  height: 500px;
  background: url(../assets/img/product/h1-1.jpg);
  background-size: 100% 100%;
  background-position: center;
  .text {
    font-size: 64px;
    font-weight: 600;
    margin-left: 50px;
  }
  .text1 {
    color: #fff;
    margin-bottom: 5px;
  }
  .text2 {
    color: #ffef88;
  }
  .w {
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 80px;
  }
}
.h2 {
  width: 100%;
  height: 412px;
  background-color: #f0f0f0;
  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    .l {
      width: 600px;
      h3 {
        padding-top: 100px;
      }
      font-size: 18px;
      color: #242b3d;
      line-height: 2;
    }
    .r {
      width: 600px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      img {
        width: 520px;
        height: 360px;
      }
    }
  }
}

.h3 {
  height: 634px;
  width: 100%;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .r {
      img {
        width: 640px;
        height: 360px;
      }
    }
    .l {
      width: 350px;
      margin-right: 70px;
      .text1 {
        font-size: 46px;
        font-weight: 600;
        color: #d5352e;
        margin-bottom: 5px;
      }
      .text2 {
        margin-top: 10px;
        line-height: 2;
        color: #242b3d;
        font-size: 18px;
      }
    }
  }
}

.h4 {
  width: 100%;
  height: 588px;
  background-color: #f0f0f0;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .r {
      margin-left: 40px;
      .text1 {
        font-size: 46px;
        font-weight: 600;
        color: #d5352e;
        margin-bottom: 5px;
      }
      .text2 {
        margin-top: 10px;
        line-height: 2;
        color: #242b3d;
        font-size: 18px;
      }
    }
  }
}
.h10 {
  width: 100%;
  height: 245px;
  background-color: #fff;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .lis1 {
      padding: 38px 0;
      color: #555555;
      font-size: 14px;
    }
    .lis2 {
      display: flex;
      align-items: center;
      .l {
        width: 960px;
        height: 100px;
        border: 1px solid #dddddd;
        display: flex;
        align-items: center;

        img {
          padding-left: 20px;
          width: 51px;
          height: 57px;
        }
        .right {
          margin-left: 30px;
          font-size: 14px;
          color: #555555;
          width: 780px;
        }
      }
      .r {
        margin-left: 15px;
        font-size: 15px;
        color: #555555;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product.vue